module.exports = require("@ember/application");